module.exports = __webpack_public_path__ + "img/LV3.75084fcf.webp";